/* Superior motion: hero word rotation, count-up figures, scroll reveals, cursor glow.
   Content is complete in the HTML; this only animates it. Nothing in the first screen is hidden,
   and everything is skipped for visitors who prefer reduced motion. */
(function () {
  if (window.supMotionReady) return;
  window.supMotionReady = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.documentElement;
  root.classList.add('sup-js');

  function belowFold(el) {
    return el.getBoundingClientRect().top > window.innerHeight * 0.92;
  }

  /* ---------- Hero: rotating accent word (one pass, lands back on the original word) */
  function rotateWords() {
    var el = document.querySelector('[data-sup-rotate]');
    if (!el) return;
    var em = el.querySelector('em');
    var words = (el.getAttribute('data-sup-rotate') || '').split(',').map(function (w) { return w.trim(); }).filter(Boolean);
    if (!em || words.length < 2) return;
    var original = em.textContent;
    var sequence = words.concat([original]);

    var visible = document.createElement('span');
    visible.className = 'sup-rotator';
    visible.setAttribute('aria-hidden', 'true');
    visible.textContent = original;
    var spoken = document.createElement('span');
    spoken.className = 'sup-visually-hidden';
    spoken.textContent = original;
    em.textContent = '';
    em.appendChild(visible);
    em.appendChild(spoken);

    // Reserve the widest word so the heading never reflows (no layout shift).
    var widest = 0;
    sequence.forEach(function (w) { visible.textContent = w; widest = Math.max(widest, visible.getBoundingClientRect().width); });
    visible.textContent = original;
    visible.style.minWidth = Math.ceil(widest) + 'px';

    var i = 0;
    setTimeout(function step() {
      visible.classList.add('is-out');
      setTimeout(function () {
        visible.textContent = sequence[i];
        visible.classList.remove('is-out');
        i += 1;
        if (i < sequence.length) setTimeout(step, 1300);
      }, 220);
    }, 1400);
  }

  /* ---------- Count-up figures */
  var NUM = /(\d+(?:\.\d+)?)/;
  function parseFigure(el) {
    // "42 <em>→</em> 93": count from the left value to the right value. "20+": count from 0.
    var nodes = [];
    el.childNodes.forEach(function (n) { if (n.nodeType === 3 && NUM.test(n.nodeValue)) nodes.push(n); });
    if (!nodes.length) return null;
    var target = nodes[nodes.length - 1];
    var to = parseFloat(target.nodeValue.match(NUM)[1]);
    var from = nodes.length > 1 ? parseFloat(nodes[0].nodeValue.match(NUM)[1]) : 0;
    if (to === from) return null;
    var decimals = (target.nodeValue.match(NUM)[1].split('.')[1] || '').length;
    return { node: target, original: target.nodeValue, from: from, to: to, decimals: decimals };
  }
  function setFigure(f, v) {
    f.node.nodeValue = f.original.replace(NUM, v.toFixed(f.decimals));
  }
  function runFigure(f) {
    var start = null, dur = 1400;
    function frame(t) {
      if (start === null) start = t;
      var p = Math.min(1, (t - start) / dur);
      var eased = 1 - Math.pow(1 - p, 3);
      setFigure(f, f.from + (f.to - f.from) * eased);
      if (p < 1) requestAnimationFrame(frame); else f.node.nodeValue = f.original;
    }
    requestAnimationFrame(frame);
  }

  /* ---------- Scroll reveals */
  var REVEAL = '.sup-section-head, .sup-card, .sup-case, .sup-point, .sup-step, .sup-stats, .sup-case-feature, .sup-faq details, .sup-cta, .sup-split > *, .sup-logos li';

  function init() {
    rotateWords();
    if (!('IntersectionObserver' in window)) return;

    var figures = [];
    document.querySelectorAll('.sup-stat__value').forEach(function (el) {
      if (!belowFold(el)) return; // figures already on screen stay as they are
      var f = parseFigure(el);
      if (!f) return;
      setFigure(f, f.from);
      el.supFigure = f;
      figures.push(el);
    });
    var figObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        figObs.unobserve(e.target);
        runFigure(e.target.supFigure);
      });
    }, { rootMargin: '0px 0px -12% 0px' });
    figures.forEach(function (el) { figObs.observe(el); });

    var revealObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        revealObs.unobserve(e.target);
        e.target.classList.add('is-in');
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll(REVEAL).forEach(function (el) {
      if (!belowFold(el)) return;
      var siblings = Array.prototype.indexOf.call(el.parentNode.children, el);
      el.style.setProperty('--sup-delay', Math.min(siblings, 5) * 70 + 'ms');
      el.classList.add('sup-reveal');
      revealObs.observe(el);
    });

    var lineObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        lineObs.unobserve(e.target);
        e.target.classList.add('is-drawn');
      });
    }, { rootMargin: '0px 0px -15% 0px' });
    document.querySelectorAll('.sup-steps').forEach(function (el) { el.classList.add('sup-steps--animate'); lineObs.observe(el); });
  }

  /* ---------- Cursor glow (mouse only) */
  function glow() {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    document.addEventListener('pointermove', function (e) {
      var card = e.target.closest && e.target.closest('.sup-card, .sup-case, .sup-stat, .sup-cta, .sup-case-feature');
      if (!card) return;
      var r = card.getBoundingClientRect();
      card.style.setProperty('--mx', (e.clientX - r.left) + 'px');
      card.style.setProperty('--my', (e.clientY - r.top) + 'px');
    }, { passive: true });
  }

  /* ---------- Article tables: wrap, and show a scroll cue when wider than the column */
  function tables() {
    document.querySelectorAll('.sup-article__body table').forEach(function (t) {
      if (t.parentNode.classList.contains('sup-table')) return;
      var wrap = document.createElement('div');
      wrap.className = 'sup-table';
      var hint = document.createElement('p');
      hint.className = 'sup-table__hint';
      hint.textContent = 'Scroll sideways to see the full table';
      t.parentNode.insertBefore(wrap, t);
      wrap.appendChild(hint);
      wrap.appendChild(t);
      function check() {
        var scrollable = t.scrollWidth > t.clientWidth + 2;
        wrap.classList.toggle('is-scrollable', scrollable);
        wrap.classList.toggle('is-end', scrollable && t.scrollLeft + t.clientWidth >= t.scrollWidth - 4);
      }
      t.addEventListener('scroll', check, { passive: true });
      window.addEventListener('resize', check);
      check();
    });
  }

  function start() {
    tables();
    if (reduce) return;
    init();
    glow();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
